import { useCallback } from 'react';
import { useReactFlow } from 'reactflow';

export const useNodeTitle = (id, data, titleKey = 'nodeTitle') => {
    const { setNodes } = useReactFlow();
    const { onSave } = data;

    const onTitleChange = useCallback((newTitle) => {
        // Update local state
        setNodes((nodes) =>
            nodes.map((node) => {
                if (node.id === id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            [titleKey]: newTitle,
                        },
                    };
                }
                return node;
            })
        );

        // Persist to DB
        if (onSave) {
            onSave(id, { [titleKey]: newTitle });
        }
    }, [id, setNodes, onSave, titleKey]);

    return onTitleChange;
};
